export const isProd = import.meta.env.VITE_PROD;
export const apiUrl = import.meta.env.VITE_BASE_URL;
export const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
export const assetsUrl = './assets/';
